import { Component, type ErrorInfo, type ReactNode } from "react";
import { errorReporter } from "../lib/errorReporter";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    errorReporter.captureException(error, {
      source: "react-error-boundary",
      componentStack: info.componentStack ?? undefined,
    });
    // Best effort: get the report out before the user reloads.
    errorReporter.flush();
  }

  override render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-card">
            <h2>Something went wrong</h2>
            <p>
              The app hit an unexpected error. It has been reported — reloading
              usually fixes it.
            </p>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Reload app
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
